export const reMeasurementUnitConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_MEASUREMENT_UNIT_SUCCESS',
		REQUEST : 'GET_PAGED_MEASUREMENT_UNIT_REQUEST',
		FAILURE : 'GET_PAGED_MEASUREMENT_UNIT_FAILURE'
	},
	GetPagedAudit: {
		SUCCESS : 'GET_PAGED_AUDIT_MEASUREMENT_UNIT_SUCCESS',
		REQUEST : 'GET_PAGED_AUDIT_MEASUREMENT_UNIT_REQUEST',
		FAILURE : 'GET_PAGED_AUDIT_MEASUREMENT_UNIT_FAILURE'
	},
	GetPagedAll: {
		REQUEST : 'GET_PAGED_ALL_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'GET_PAGED_ALL_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'GET_PAGED_ALL_MEASUREMENT_UNIT_FAILURE'
	},
	GetList: {
		REQUEST : 'GET_LIST_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'GET_LIST_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'GET_LIST_MEASUREMENT_UNIT_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'CREATE_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'CREATE_MEASUREMENT_UNIT_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'DELETE_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'DELETE_MEASUREMENT_UNIT_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'UPDATE_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'UPDATE_MEASUREMENT_UNIT_FAILURE'
	},
	Restore: {
		REQUEST : 'RESTORE_MEASUREMENT_UNIT_REQUEST',
		SUCCESS : 'RESTORE_MEASUREMENT_UNIT_SUCCESS',
		FAILURE : 'RESTORE_MEASUREMENT_UNIT_FAILURE'
	},
	CLEAR: 'CLEAR_MEASUREMENT_UNIT'
}